import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import supportedLocales from 'locales/supported-locales.json';
import { ga } from 'helpers/multitrack';
import { isEmpty } from 'helpers/verify';
import { segment } from 'helpers/segment';
import { DisclosureArrow } from 'components/DisclosureArrow/DisclosureArrow';

const languageNames = {
  'fr-FR': 'Français',
  'en-US': 'English (United States)',
  'en-AU': 'English (Australia)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  da: 'Dansk',
  nb: 'Bokmål',
  pt: 'Português',
  es: 'Español',
};

export class LocaleSwitcher extends React.Component {
  constructor() {
    super();
    this.localeClicked = this.localeClicked.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onCloseModal() {
    const currentLocale = this.getCurrentLocale();
    segment.track('Footer', {
      action: 'Click - Close Locale Modal',
      label: currentLocale,
    });
    ga('Footer', 'Click - Close Locale Modal', currentLocale);
    this.props.hideModal('LocaleModal');
  }

  getCurrentLocale() {
    const {
      intl: { locale: currentLocale },
    } = this.props;

    return currentLocale;
  }

  localeClicked() {
    const currentLocale = this.getCurrentLocale();
    this.props.showModal('LocaleModal', {
      currentLocale,
      locales: this.locales(),
      onModalClose: this.onCloseModal,
      onSelect: this.props.updateAccountLocale,
    });
    segment.track('Footer', {
      action: 'Click - Current Locale',
      label: currentLocale,
    });
    ga('Footer', 'Click - Current Locale', currentLocale);
  }

  locales() {
    return supportedLocales.map(locale => ({
      languageName: languageNames[locale],
      localeKey: locale,
    }));
  }

  render() {
    const { className, children } = this.props;

    const currentLocale = this.getCurrentLocale();
    const locales = this.locales();

    if (isEmpty(locales)) {
      return null;
    }

    return (
      <span className={className}>
        {children({
          name: languageNames[currentLocale],
          locale: currentLocale,
          onClick: this.localeClicked,
        })}
      </span>
    );
  }
}

LocaleSwitcher.defaultProps = {
  className: 'LocaleSwitcher',
  children: ({
    /* eslint-disable react/prop-types */
    locale,
    onClick,
    name,
    /* eslint-enable */
  }) => (
    <a key={locale} onClick={onClick}>
      {name}
      <DisclosureArrow className="LocaleSwitcher__arrow" svgClassName="LocaleSwitcher__arrow__svg" />
    </a>
  ),
};

LocaleSwitcher.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
  children: PropTypes.func,
  hideModal: PropTypes.func,
  showModal: PropTypes.func,
  updateAccountLocale: PropTypes.func.isRequired,
};
